import './bootstrap';

import drawerFactory from './components/drawer';


document.addEventListener('alpine:init', () => {
              
    // console.log('app.js| alpine:init');

    // Alpine.store('notifications', {
    //     items: [],
       
    //     notify(message) { 
    //       this.items.push(message)
    //       console.log('app.js| notify:', message);
    //       // Log the specific store data
    //     //   console.log(Alpine.store('app.js: notifications'));
    //     }
    //   });

    // Alpine.store('ui', {
    //     toasts: [],          // {id, title, body, level}
    //     unread: 0,          // badge number for messages
    //     /** helpers */
    //     // pushToast(toast)   { this.toasts.unshift(toast) },
    //     // clearToasts()      { this.toasts = [] },
    //     // setUnread(count)   { this.unread = count },
    // });
    // console.log('open:'+this.open);

    Alpine.data('drawer', drawerFactory);

    // // ✅ Use Alpine.store() – NOT $store – in normal JS
    // console.log('maindrawer store:', Alpine.store('maindrawer'));          // {open: false, toggle: f}
    // console.log('maindrawer open?', Alpine.store('maindrawer').open);      // false
})

// function scb_teste_1(msg) {
//     console.log('scb_teste_1:'+msg);
//     Alpine.store('notifications').notify('Teste 1');
// }